import React from 'react'
import '../styles/Users.css'

const Users = () => {
  return (
    <div>Users</div>
  )
}

export default Users